<template>
  <div v-if="isDataLoaded" id="view-slide-container">

    <div class="container is-fluid levebar-container">
      <nav class="level app-levelbar">
        <div class="level-left is-hidden-mobile">
          <breadcrumb v-if="breadcrumbList" :list="breadcrumbList"></breadcrumb>
        </div>
      </nav>
    </div>

    <div id="view-slide">
      <menu-info v-if="menu" :menu="menu"></menu-info>
      <div class="margin-comp"></div>
      <slide-list :slides="slides" :menu="menu"></slide-list>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../Util/Breadcrumb'
  import MenuInfo from './MenuInfo'
  import SlideList from './SlideList'

  export default {
    components: {
      Breadcrumb,
      MenuInfo,
      SlideList
    },

    data () {
      return {
        breadcrumbList: null,
        coachId: this.$store.state.route.params.id,
        categoryId: this.$store.state.route.params.cat,
        isDataLoaded: false
      }
    },

    mounted () {
      this.getCoachData()
      this.getSlideList()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      coach () {
        return this.$store.state.coach.data
      },

      menu () {
        return this.$store.state.slide.menu
      },

      slides () {
        return this.$store.state.slide.list
      }
    },

    methods: {
      getCoachData () {
        this.$store.dispatch('getCoach', this.$store.state.route.params.id)
      },

      getSlideList () {
        this.$store.dispatch('getSlideList', {coach: this.coachId, category: this.categoryId})
      }
    },

    watch: {
      currentEvent: function (val) {
      },

      coach: function (coach) {
        if (coach && this.menu) {
          let id = coach.id
          let name = coach.languages[0].pivot.name
          let menuId = this.menu.id
          let menuName = this.menu.languages[0].pivot.name

          this.breadcrumbList = [
            { name: 'Início', path: '/' },
            { name: `${name}`, path: `/${id}` },
            { name: `${menuName}`, path: `/${menuId}` }
          ]
        }
      },

      menu: function (menu) {
        if (menu && this.coach) {
          let id = menu.id
          let name = menu.languages[0].pivot.name
          let coachId = this.coach.id
          let coachName = this.coach.languages[0].pivot.name

          this.breadcrumbList = [
            { name: 'Início', path: '/' },
            { name: `${coachName}`, path: `/${coachId}` },
            { name: `${name}`, path: `/${id}` }
          ]

          this.isDataLoaded = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .margin-comp {
    width: 100%;
    height: 20px;
  }

  #view-slide-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .content-padding {
    padding: 10px;
    background: white;
  }

  .container-margin-top {
    margin-top: 20px !important;
  }

  .flex-container-center {
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// index.vue?11d7dc77